import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './mini-gallery.scss.js';

class MiniGallery extends s {
    constructor() {
        super(...arguments);
        this.thumbnailsContainer = null;
        this.setActiveSlide = (i) => {
            var _a;
            const slot = this.shadowRoot.querySelector('slot');
            const thumbnails = (_a = this.thumbnailsContainer) === null || _a === void 0 ? void 0 : _a.querySelectorAll('img');
            slot.assignedNodes().forEach((imgSlot) => {
                // eslint-disable-next-line no-param-reassign
                imgSlot.removeAttribute('visible');
                imgSlot.setAttribute('hide', '');
            });
            const img = slot.assignedNodes()[i];
            img.removeAttribute('hide');
            img.setAttribute('visible', '');
            thumbnails.forEach(thumb => thumb.classList.remove('active'));
            thumbnails[i].classList.add('active');
        };
        this.createThumbnails = (images) => {
            this.thumbnailsContainer = this.shadowRoot.querySelector('.thumbnails');
            images.forEach((thumb, i) => {
                const img = document.createElement('img');
                img.src = thumb.src;
                img.alt = thumb.alt;
                img.tabIndex = 0;
                img.setAttribute('role', 'button');
                img.addEventListener('click', () => this.setActiveSlide(i));
                img.addEventListener('keydown', this.handleKey);
                this.thumbnailsContainer.appendChild(img);
            });
        };
        this.handleKey = (e) => {
            const target = e.target;
            if (e.key === 'Enter' || e.key === ' ')
                target.click();
        };
        this.firstUpdated = () => {
            const images = this.shadowRoot.querySelector('slot').assignedNodes();
            this.createThumbnails(images);
            this.setActiveSlide(0);
        };
    }
    render() {
        return x `<div class="mini-gallery"><div class="preview"><slot name="image"></slot></div><div class="thumbnails"></div></div>`;
    }
}
MiniGallery.styles = css_248z;
customElements.define('mini-gallery', MiniGallery);

export { MiniGallery };
